import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from 'ng-click-outside';
import { CapitalizeFirstLetterModule } from '../capitalize-firstLetter/capitalize-firstLetter.module';
import { UserSearchComponent } from './user-search/user-search.component';

@NgModule({
  declarations: [
    UserSearchComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    ClickOutsideModule,
    TranslateModule,
    CapitalizeFirstLetterModule
  ],
  exports : [
    UserSearchComponent
  ]
})
export class UserModule { }
